require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./post-barclays-has-fixed-windows-10-app-issues.json") })
        }
      }, "path---post-barclays-has-fixed-windows-10-app-issues");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---post-barclays-has-fixed-windows-10-app-issues!./.cache/json/post-barclays-has-fixed-windows-10-app-issues.json
// module id = 315
// module chunks = 231608221292675